export default __webpack_public_path__ + "static/media/icon_sentiment.38ed7277.svg";